module.exports = __webpack_public_path__ + "static/media/jyIl5tz97wf5joN6c9529pwSTOx29BLxPkYnbXx6.fb638da1.webp";